import BaseService from "./BaseService.js";

class ProjectService extends BaseService {
  get({ module }) {
    return this.apiGet({
      url: `/projects`,
    });
  }

  getData(query) {
    return this.apiGet({
      url: '/projects/data',
      params: query,
    });
  }
  getKyc(id, userId, query) {
    return this.apiGet({
      url: `/projects/${id}/kyc/${userId}`,
      params: query,
    });
  }
  getCaddReports({ id, userId, query }, signal) {
    return this.apiGet({
      url: `/projects/${id}/cadd-reports/${userId}`,
      params: query,
      signal,
    });
  }


  getById(id) {
    return this.apiGet({
      url: `/projects/${id}`,
    });
  }

  create(payload) {
    return this.apiPost({
      url: "/projects",
      data: payload,
    });
  }
  submit(payload, module) {
    const { id, ...data } = payload;
    if (id) {
      return this.apiPut({
        url: `/projects/${id}`,
        data,
      });
    }
    return this.apiPost({
      url: `/projects`,
      data,
    });
  }
  submitPme(payload) {
    const { id, ...data } = payload;
    if (id) {
      return this.apiPut({
        url: `/projects/${id}`,
        data,
      });
    }
    return this.apiPost({
      url: "/projects",
      data,
    });
  }
  submitCadd(payload) {
    const { id, ...data } = payload;
    if (id) {
      return this.apiPut({
        url: `/projects/${id}`,
        data,
      });
    }
    return this.apiPost({
      url: "/projects",
      data,
    });
  }
  updateStatus(id, status) {
    return this.apiPut({
      url: `/projects/${id}`,
      data: { status }
    })
  }

  updatePublications(projectId, payload, params = {}) {
    return this.apiPost({
      url: `/projects/${projectId}/publications`,
      data: {
        ...payload,
        params,
      },
    });
  }

  getInvitedProjects() {
    return this.apiGet({
      url: '/projects/invitations',
    });
  }

  setProjectStatus(projectId, payload) {
    return this.apiPost({
      url: `/projects/${projectId}/status`,
      data: payload,
    });
  }

  remove(id, data) {
    return this.apiDelete({
      url: `/projects/${id}/remove`,
      data: data,
    });
  }

  getLinking(parent, entityId, role = "supplier") {
    return this.apiPost({
      url: '/linking/data',
      data: {
        service: "Stakeholder",
        entity: "StakeholderEntity",
        getFormMethod: "getUserForLinkData",
        createMethod: "checkUserWithIdOrEmail",
        query: {
          namespace: "USER",
          view: "project-participant",
          role,
          module: "pme",
          parent,
          entityId
        }
      }
    });
  }

  checkUser(data = {}) {
    return this.apiPost({
      url: '/linking/check',
      data: {
        service: "Stakeholder",
        entity: "StakeholderEntity",
        getFormMethod: "getUserForLinkData",
        createMethod: "checkUserWithIdOrEmail",
        "data": {
          ...data,
          form: "generalInformation",
        }
      }
    })
  }

  inviteBack(projectId = '', userId = '', role) {
    return this.apiPost({
      url: `/projects/${projectId}/reinvite`,
      data: {
        authorId: userId,
        role
      }
    })
  }

  submitSettings(id, body) {
    return this.apiPost({
      url: `/projects/${id}/visualisation-settings`,
      data: body,
    });
  }

  getSource(id) {
    return this.apiGet({
      url: `/projects/${id}/sources`,
    });
  }
}

export default new ProjectService();
